import React from "react";
import { TspCard } from "../../../components/primitives";
import { formatDate, formatDateRange } from "../../../utils/tspFormat";
import { JOURNEY_STATUS_LABELS, JOURNEY_STATUS_PILL } from "../../../constants/tspJourneyStatus";
import { describeDuration } from "../journeyDetailModel";

// The journey's own facts and where it is in its lifecycle — all as stored on the
// server (temple, leader, dates, who approved/started/finished it). Journeys are
// no longer created with a team; an older journey that has one still shows it.
// The leader is the journey's own (the server resolves a linked user's name).
export default function JourneyOverviewCard({ journey }) {
  const { lifecycle } = journey;
  const stamp = (event) => (event.at ? `${formatDate(event.at.slice(0, 10))}${event.by ? ` by ${event.by.name}` : ""}` : null);

  const rows = [
    { label: "Temple", value: journey.temple_name || <span className="tsp-summary-empty">Not recorded</span> },
    { label: "Team Leader", value: journey.leader?.name || <span className="tsp-summary-empty">Not recorded</span> },
    { label: "Team", value: journey.team ? journey.team.name : null },
    { label: "States", value: journey.states.length ? journey.states.map((state) => state.name).join(", ") : null },
    { label: "Dates", value: formatDateRange(journey.start_date, journey.end_date) || null },
    { label: "Duration", value: describeDuration(journey) },
    { label: "Approved", value: stamp(lifecycle.approved) },
    { label: "Started", value: stamp(lifecycle.started) },
    { label: "Completed", value: stamp(lifecycle.completed) },
    { label: "Cancelled", value: stamp(lifecycle.cancelled) },
  ];

  return (
    <TspCard
      title={journey.journey_name}
      className="tsp-title-18"
      action={<span className={`tsp-status-pill ${JOURNEY_STATUS_PILL[journey.status]}`}>{JOURNEY_STATUS_LABELS[journey.status]}</span>}
    >
      <dl className="tsp-summary-list">
        {rows
          .filter((row) => row.value)
          .map((row) => (
            <div key={row.label}>
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
      </dl>
      {lifecycle.cancelled.reason && <p className="tsp-muted-text">Cancellation reason: {lifecycle.cancelled.reason}</p>}
      {journey.description && <p className="tsp-muted-text">{journey.description}</p>}
    </TspCard>
  );
}
